<template>
  <div id="app">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-main style="background-color: #d1ffd5">
          <v-container class="fill-height" fluid>
            <v-row class="align-center justify-center">
              <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                  <v-toolbar color="green darken-1" dark flat>
                    <v-toolbar-title>Система аналитики Carbis</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form @submit.prevent="auth">
                      <v-text-field
                        label="Логин"
                        prepend-icon="mdi-account"
                        type="text"
                        placeholder="Введите логин"
                        v-model="login"
                        color="green darken-2"
                        @keyup.enter="auth"
                      ></v-text-field>

                      <v-text-field
                        label="Пароль"
                        prepend-icon="mdi-lock"
                        type="password"
                        placeholder="Введите пароль"
                        v-model="password"
                        color="green darken-2"
                        @keyup.enter="auth"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn @click="auth" color="green darken-2" dark text large
                      >Войти</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-snackbar
          v-model="$store.getters.snackbar.show"
          top
          :timeout="2500"
          :color="$store.getters.snackbar.color">
            {{ $store.getters.snackbar.message }}
          </v-snackbar>
        </v-main>
      </v-app>
    </v-app>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      login: "",
      password: "",
    };
  },
  methods: {
    ...mapActions(["logIn"]),
    async auth() {
      await this.logIn({
        login: this.login,
        password: this.password,
      });
    },
  },
};
</script>
